import { render, staticRenderFns } from "./marksEntryOLevel.vue?vue&type=template&id=502723f3&scoped=true&"
import script from "./marksEntryOLevel.vue?vue&type=script&lang=js&"
export * from "./marksEntryOLevel.vue?vue&type=script&lang=js&"
import style0 from "./marksEntryOLevel.vue?vue&type=style&index=0&id=502723f3&lang=scss&scoped=true&"
import style1 from "./marksEntryOLevel.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./marksEntryOLevel.vue?vue&type=style&index=2&id=502723f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502723f3",
  null
  
)

export default component.exports